import { createSlice } from '@reduxjs/toolkit';
import {getPageType} from "../routes";

const sheetSlice = createSlice({
  name: 'sheet',
  initialState: {
    isVisible: false,
  },
  reducers: {
    openSheet: state => {
      state.isVisible = true;

     // *** Adobe "view_mini_cart" event every time side cart is opened ***
     try {
       const basketStatesFromLocalStorage = JSON.parse(localStorage.getItem('BASKET_CACHE_KEY'));
       if (
         basketStatesFromLocalStorage &&
         basketStatesFromLocalStorage.products?.length > 0 &&
         basketStatesFromLocalStorage.products[0].product
       ) {
         if (!window.adobeDataLayer) {
           window.adobeDataLayer = [];
         }
         window.adobeDataLayer.push({
           event: 'view_mini_cart',
           page_info: {
             page_url: window.location.href,
             page_title: document.title,
             page_type: getPageType(window.location.pathname),
             language: (navigator.language || 'en').toLowerCase()
           },
           items: basketStatesFromLocalStorage.products.map(item => ({
             item_id: item.product.creator,
             item_name: item.product.name,
             item_brand: item.product.category || '',
             item_description: item.product.description || '',
             item_category: item.product.category || '',
             price: item.amount,
             quantity: item.quantity,
             currency: basketStatesFromLocalStorage.currency?.toUpperCase() || 'AUD'
           })),
           order_summary: {
             admin_contribution: basketStatesFromLocalStorage.adminCost || 0,
             donation_contribution: basketStatesFromLocalStorage.total || 0,
             total_value: basketStatesFromLocalStorage.grandTotal || 0,
             currency: basketStatesFromLocalStorage.currency?.toUpperCase() || 'AUD'
           }
         });
       }
     } catch (err) {
       // console.warn("Failed to push mini cart event", err);
     }
     // *** END Adobe "view_mini_cart" event ***

    },
    closeSheet: state => {
      state.isVisible = false;
    },
    toggleSheet: state => {
      state.isVisible = !state.isVisible;
    },
  },
});

export const { openSheet, closeSheet, toggleSheet } = sheetSlice.actions;

export const selectSheetVisibility = state => state.sheet.isVisible;

export default sheetSlice.reducer;
